import React from "react";
import { HeaderText } from "assets/js/Styles";
import styled from "styled-components";
import { Col } from "reactstrap";
import RecipientForm from "./Form";

const FormSection = styled.div`
  margin-top: 44px;
  padding-bottom: 4rem;
`;

const Wrapper = styled.div`
  margin-top: 50px;
`;

const HeaderTextSection = styled.div`
  margin-top: 24px;
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  align-items: center;
`;

const RecipientDetails = () => {
  return (
    <Wrapper>
      <Col className="container">
        <HeaderTextSection>
          <HeaderText>{"Recipient Details"}</HeaderText>
        </HeaderTextSection>

        <FormSection>
          <RecipientForm />
        </FormSection>
      </Col>
    </Wrapper>
  );
};

export default RecipientDetails;
